import config from '../../config'
import accounting from 'accounting'

export const formatCurrency = (value, options) => {
  const formatConfig = Object.assign({}, config.currencyFormat, options)
  return accounting.formatMoney(value, formatConfig)
}
